<template>
  <el-dialog
    title="Add company"
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <div v-loading="fetchInProgress || processing">
      <el-form label-position="top">
        <el-form-item>
          <el-input
            ref="input"
            v-model="search"
            class="inline-input"
            placeholder="Search"
            @input="debouncedSearch"
            @keyup.prevent.enter="addStartup"
          />
        </el-form-item>
      </el-form>

      <p
        v-for="error in errors"
        :key="error"
        class="validation-text text-danger"
      >
        {{ error }}
      </p>

      <el-table v-loading="fetchInProgress" :data="startups">
        <el-table-column label="Company" prop="name">
          <template slot-scope="{ row }">
            <a href @click.prevent="chooseStartup(row)">{{ row.name }}</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import http from 'services/http'

export default {
  props: {
    organizationId: { type: String },
    eventId: { type: String },
  },
  data() {
    return {
      visible: false,
      processing: false,
      fetchInProgress: false,
      search: '',
      startups: [],
      debouncedSearch: null,
      errors: [],
    }
  },

  created() {
    this.debouncedSearch = _.debounce(this.fetch, 200)
  },

  methods: {
    open() {
      const self = this
      this.visible = true
      this.fetchInProgress = false
      this.processing = false
      this.startups = []
      this.errors = []

      self.$nextTick(function () {
        self.$el.querySelector('input').focus()
      })
    },

    close() {
      this.visible = false
    },

    async addStartup(item) {
      console.log(' => addStartup', item)
      this.$emit('added', {})
      this.close()
    },

    async fetch(text) {
      if (!text) {
        this.startups = []
        return
      }
      this.fetchInProgress = true
      const url = `/organizations/${this.organizationId}/startups`
      console.log(' => performSearch', text)
      console.log(' => GET ', url)
      const request = http.getAuthed(url, { search: text })
      try {
        const response = await request
        this.startups = response.data.results
      } finally {
        this.fetchInProgress = false
      }
    },

    async chooseStartup(startup) {
      this.processing = true
      this.errors = []
      const { id, name } = startup
      const url = `/events/${this.eventId}/add-startups`
      const request = http.postAuthed(url, { startups: [id] })
      try {
        const response = await request
        this.close()
        this.$emit('added', { startup })
      } catch (error) {
        if (error.response && error.response.data.non_field_errors) {
          this.errors = error.response.data.non_field_errors
        } else {
          throw error
        }
      } finally {
        this.processing = false
      }
    },
  },
}
</script>
